/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {convertFetchResponseToReactQueryResponse} from '../tools';
import {ApiResponse} from '../types';
import {
    useMutation,
    UseMutationOptions,
    UseMutationResult,
    useQuery,
    useQueryClient,
    UseQueryOptions,
    UseQueryResult,
    QueryClient,
    useInfiniteQuery,
    UseInfiniteQueryOptions,
    UseInfiniteQueryResult,
} from 'react-query';
import {
    AdminAuthChangePasswordRequest,
    AdminAuthChangePasswordRequestFromJSON,
    AdminAuthChangePasswordRequestToJSON,
    AuthMeResponse,
    AuthMeResponseFromJSON,
    AuthMeResponseToJSON,
    AuthRequest,
    AuthRequestFromJSON,
    AuthRequestToJSON,
    AuthTokenResponse,
    AuthTokenResponseFromJSON,
    AuthTokenResponseToJSON,
} from '../models';

import {AuthApi, AuthApiPostAdminChangePasswordRequest, AuthApiPostAdminLogInRequest} from './AuthApi';

type GetMeQueryOptions = UseQueryOptions<AuthMeResponse, Array<Error>, AuthMeResponse, ['getMe']>;

let useGetMeQueryGlobalOptions:
    | ((queryClient: QueryClient, options?: GetMeQueryOptions) => GetMeQueryOptions | undefined)
    | undefined = undefined;

export function registerUseGetMeQueryGlobalOptions(
    callback: (queryClient: QueryClient, options?: GetMeQueryOptions) => GetMeQueryOptions | undefined
) {
    useGetMeQueryGlobalOptions = callback;
}

export function getGetMeQueryKey(): ['getMe'] {
    return ['getMe'];
}

export function useGetMeQuery(options?: GetMeQueryOptions): UseQueryResult<AuthMeResponse, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getGetMeQueryKey(),
        async ({signal}) => convertFetchResponseToReactQueryResponse(await new AuthApi().getMe({signal})),
        {
            ...options,
            ...useGetMeQueryGlobalOptions?.(queryClient, options),
        }
    );
}

type GetMeMutationOptions = UseMutationOptions<AuthMeResponse, Array<Error>>;

let useGetMeMutationGlobalOptions:
    | ((queryClient: QueryClient, options?: GetMeMutationOptions) => GetMeMutationOptions | undefined)
    | undefined = undefined;

export function registerUseGetMeMutationGlobalOptions(
    callback: (queryClient: QueryClient, options?: GetMeMutationOptions) => GetMeMutationOptions | undefined
) {
    useGetMeMutationGlobalOptions = callback;
}

export function useGetMeMutation(
    options?: GetMeMutationOptions
): UseMutationResult<AuthMeResponse, Array<runtime.ApiError>, void> {
    const queryClient = useQueryClient();
    return useMutation(async (params) => convertFetchResponseToReactQueryResponse(await new AuthApi().getMe()), {
        ...options,
        ...useGetMeMutationGlobalOptions?.(queryClient, options),
    });
}

export function getGetMeInfiniteQueryKey(): ['getMe-infinite'] {
    return ['getMe-infinite'];
}

export function useGetMeInfiniteQuery(
    options?: Omit<
        UseInfiniteQueryOptions<
            AuthMeResponse,
            Array<runtime.ApiError>,
            AuthMeResponse,
            AuthMeResponse,
            ['getMe-infinite']
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AuthMeResponse, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getGetMeInfiniteQueryKey(),
        async (context) => convertFetchResponseToReactQueryResponse(await new AuthApi().getMe()),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type PostAdminChangePasswordQueryOptions = UseQueryOptions<
    void,
    Array<Error>,
    void,
    ['postAdminChangePassword', AuthApiPostAdminChangePasswordRequest]
>;

let usePostAdminChangePasswordQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: AuthApiPostAdminChangePasswordRequest,
          options?: PostAdminChangePasswordQueryOptions
      ) => PostAdminChangePasswordQueryOptions | undefined)
    | undefined = undefined;

export function registerUsePostAdminChangePasswordQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: AuthApiPostAdminChangePasswordRequest,
        options?: PostAdminChangePasswordQueryOptions
    ) => PostAdminChangePasswordQueryOptions | undefined
) {
    usePostAdminChangePasswordQueryGlobalOptions = callback;
}

export function getPostAdminChangePasswordQueryKey(
    params: AuthApiPostAdminChangePasswordRequest
): ['postAdminChangePassword', AuthApiPostAdminChangePasswordRequest] {
    return ['postAdminChangePassword', params];
}

export function usePostAdminChangePasswordQuery(
    params: AuthApiPostAdminChangePasswordRequest,
    options?: PostAdminChangePasswordQueryOptions
): UseQueryResult<void, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getPostAdminChangePasswordQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new AuthApi().postAdminChangePassword(params, {signal})),
        {
            ...options,
            ...usePostAdminChangePasswordQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type PostAdminChangePasswordMutationOptions = UseMutationOptions<
    void,
    Array<Error>,
    AuthApiPostAdminChangePasswordRequest
>;

let usePostAdminChangePasswordMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: PostAdminChangePasswordMutationOptions
      ) => PostAdminChangePasswordMutationOptions | undefined)
    | undefined = undefined;

export function registerUsePostAdminChangePasswordMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: PostAdminChangePasswordMutationOptions
    ) => PostAdminChangePasswordMutationOptions | undefined
) {
    usePostAdminChangePasswordMutationGlobalOptions = callback;
}

export function usePostAdminChangePasswordMutation(
    options?: PostAdminChangePasswordMutationOptions
): UseMutationResult<void, Array<runtime.ApiError>, AuthApiPostAdminChangePasswordRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) => convertFetchResponseToReactQueryResponse(await new AuthApi().postAdminChangePassword(params)),
        {
            ...options,
            ...usePostAdminChangePasswordMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getPostAdminChangePasswordInfiniteQueryKey(
    params: AuthApiPostAdminChangePasswordRequest
): ['postAdminChangePassword-infinite', AuthApiPostAdminChangePasswordRequest] {
    return ['postAdminChangePassword-infinite', params];
}

export function usePostAdminChangePasswordInfiniteQuery(
    params: AuthApiPostAdminChangePasswordRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            void,
            Array<runtime.ApiError>,
            void,
            void,
            ['postAdminChangePassword-infinite', AuthApiPostAdminChangePasswordRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<void, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getPostAdminChangePasswordInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new AuthApi().postAdminChangePassword({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type PostAdminLogInQueryOptions = UseQueryOptions<
    AuthTokenResponse,
    Array<Error>,
    AuthTokenResponse,
    ['postAdminLogIn', AuthApiPostAdminLogInRequest]
>;

let usePostAdminLogInQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: AuthApiPostAdminLogInRequest,
          options?: PostAdminLogInQueryOptions
      ) => PostAdminLogInQueryOptions | undefined)
    | undefined = undefined;

export function registerUsePostAdminLogInQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: AuthApiPostAdminLogInRequest,
        options?: PostAdminLogInQueryOptions
    ) => PostAdminLogInQueryOptions | undefined
) {
    usePostAdminLogInQueryGlobalOptions = callback;
}

export function getPostAdminLogInQueryKey(
    params: AuthApiPostAdminLogInRequest
): ['postAdminLogIn', AuthApiPostAdminLogInRequest] {
    return ['postAdminLogIn', params];
}

export function usePostAdminLogInQuery(
    params: AuthApiPostAdminLogInRequest,
    options?: PostAdminLogInQueryOptions
): UseQueryResult<AuthTokenResponse, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getPostAdminLogInQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new AuthApi().postAdminLogIn(params, {signal})),
        {
            ...options,
            ...usePostAdminLogInQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type PostAdminLogInMutationOptions = UseMutationOptions<AuthTokenResponse, Array<Error>, AuthApiPostAdminLogInRequest>;

let usePostAdminLogInMutationGlobalOptions:
    | ((queryClient: QueryClient, options?: PostAdminLogInMutationOptions) => PostAdminLogInMutationOptions | undefined)
    | undefined = undefined;

export function registerUsePostAdminLogInMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: PostAdminLogInMutationOptions
    ) => PostAdminLogInMutationOptions | undefined
) {
    usePostAdminLogInMutationGlobalOptions = callback;
}

export function usePostAdminLogInMutation(
    options?: PostAdminLogInMutationOptions
): UseMutationResult<AuthTokenResponse, Array<runtime.ApiError>, AuthApiPostAdminLogInRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) => convertFetchResponseToReactQueryResponse(await new AuthApi().postAdminLogIn(params)),
        {
            ...options,
            ...usePostAdminLogInMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getPostAdminLogInInfiniteQueryKey(
    params: AuthApiPostAdminLogInRequest
): ['postAdminLogIn-infinite', AuthApiPostAdminLogInRequest] {
    return ['postAdminLogIn-infinite', params];
}

export function usePostAdminLogInInfiniteQuery(
    params: AuthApiPostAdminLogInRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            AuthTokenResponse,
            Array<runtime.ApiError>,
            AuthTokenResponse,
            AuthTokenResponse,
            ['postAdminLogIn-infinite', AuthApiPostAdminLogInRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AuthTokenResponse, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getPostAdminLogInInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new AuthApi().postAdminLogIn({...params, page: context.pageParam || (params as any)?.page} as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type PostAdminRefreshAccessTokenQueryOptions = UseQueryOptions<
    AuthTokenResponse,
    Array<Error>,
    AuthTokenResponse,
    ['postAdminRefreshAccessToken']
>;

let usePostAdminRefreshAccessTokenQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: PostAdminRefreshAccessTokenQueryOptions
      ) => PostAdminRefreshAccessTokenQueryOptions | undefined)
    | undefined = undefined;

export function registerUsePostAdminRefreshAccessTokenQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: PostAdminRefreshAccessTokenQueryOptions
    ) => PostAdminRefreshAccessTokenQueryOptions | undefined
) {
    usePostAdminRefreshAccessTokenQueryGlobalOptions = callback;
}

export function getPostAdminRefreshAccessTokenQueryKey(): ['postAdminRefreshAccessToken'] {
    return ['postAdminRefreshAccessToken'];
}

export function usePostAdminRefreshAccessTokenQuery(
    options?: PostAdminRefreshAccessTokenQueryOptions
): UseQueryResult<AuthTokenResponse, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getPostAdminRefreshAccessTokenQueryKey(),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new AuthApi().postAdminRefreshAccessToken({signal})),
        {
            ...options,
            ...usePostAdminRefreshAccessTokenQueryGlobalOptions?.(queryClient, options),
        }
    );
}

type PostAdminRefreshAccessTokenMutationOptions = UseMutationOptions<AuthTokenResponse, Array<Error>>;

let usePostAdminRefreshAccessTokenMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: PostAdminRefreshAccessTokenMutationOptions
      ) => PostAdminRefreshAccessTokenMutationOptions | undefined)
    | undefined = undefined;

export function registerUsePostAdminRefreshAccessTokenMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: PostAdminRefreshAccessTokenMutationOptions
    ) => PostAdminRefreshAccessTokenMutationOptions | undefined
) {
    usePostAdminRefreshAccessTokenMutationGlobalOptions = callback;
}

export function usePostAdminRefreshAccessTokenMutation(
    options?: PostAdminRefreshAccessTokenMutationOptions
): UseMutationResult<AuthTokenResponse, Array<runtime.ApiError>, void> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) => convertFetchResponseToReactQueryResponse(await new AuthApi().postAdminRefreshAccessToken()),
        {
            ...options,
            ...usePostAdminRefreshAccessTokenMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getPostAdminRefreshAccessTokenInfiniteQueryKey(): ['postAdminRefreshAccessToken-infinite'] {
    return ['postAdminRefreshAccessToken-infinite'];
}

export function usePostAdminRefreshAccessTokenInfiniteQuery(
    options?: Omit<
        UseInfiniteQueryOptions<
            AuthTokenResponse,
            Array<runtime.ApiError>,
            AuthTokenResponse,
            AuthTokenResponse,
            ['postAdminRefreshAccessToken-infinite']
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AuthTokenResponse, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getPostAdminRefreshAccessTokenInfiniteQueryKey(),
        async (context) => convertFetchResponseToReactQueryResponse(await new AuthApi().postAdminRefreshAccessToken()),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type PostAdminRefreshRefreshTokenQueryOptions = UseQueryOptions<
    void,
    Array<Error>,
    void,
    ['postAdminRefreshRefreshToken']
>;

let usePostAdminRefreshRefreshTokenQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: PostAdminRefreshRefreshTokenQueryOptions
      ) => PostAdminRefreshRefreshTokenQueryOptions | undefined)
    | undefined = undefined;

export function registerUsePostAdminRefreshRefreshTokenQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: PostAdminRefreshRefreshTokenQueryOptions
    ) => PostAdminRefreshRefreshTokenQueryOptions | undefined
) {
    usePostAdminRefreshRefreshTokenQueryGlobalOptions = callback;
}

export function getPostAdminRefreshRefreshTokenQueryKey(): ['postAdminRefreshRefreshToken'] {
    return ['postAdminRefreshRefreshToken'];
}

export function usePostAdminRefreshRefreshTokenQuery(
    options?: PostAdminRefreshRefreshTokenQueryOptions
): UseQueryResult<void, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getPostAdminRefreshRefreshTokenQueryKey(),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new AuthApi().postAdminRefreshRefreshToken({signal})),
        {
            ...options,
            ...usePostAdminRefreshRefreshTokenQueryGlobalOptions?.(queryClient, options),
        }
    );
}

type PostAdminRefreshRefreshTokenMutationOptions = UseMutationOptions<void, Array<Error>>;

let usePostAdminRefreshRefreshTokenMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: PostAdminRefreshRefreshTokenMutationOptions
      ) => PostAdminRefreshRefreshTokenMutationOptions | undefined)
    | undefined = undefined;

export function registerUsePostAdminRefreshRefreshTokenMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: PostAdminRefreshRefreshTokenMutationOptions
    ) => PostAdminRefreshRefreshTokenMutationOptions | undefined
) {
    usePostAdminRefreshRefreshTokenMutationGlobalOptions = callback;
}

export function usePostAdminRefreshRefreshTokenMutation(
    options?: PostAdminRefreshRefreshTokenMutationOptions
): UseMutationResult<void, Array<runtime.ApiError>, void> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) => convertFetchResponseToReactQueryResponse(await new AuthApi().postAdminRefreshRefreshToken()),
        {
            ...options,
            ...usePostAdminRefreshRefreshTokenMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getPostAdminRefreshRefreshTokenInfiniteQueryKey(): ['postAdminRefreshRefreshToken-infinite'] {
    return ['postAdminRefreshRefreshToken-infinite'];
}

export function usePostAdminRefreshRefreshTokenInfiniteQuery(
    options?: Omit<
        UseInfiniteQueryOptions<void, Array<runtime.ApiError>, void, void, ['postAdminRefreshRefreshToken-infinite']>,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<void, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getPostAdminRefreshRefreshTokenInfiniteQueryKey(),
        async (context) => convertFetchResponseToReactQueryResponse(await new AuthApi().postAdminRefreshRefreshToken()),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}
